import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'

export const AppTermsAndConditions: React.FC = () => {
    const data = [
        {
            'type': 1,
            'content': 'TERMS AND CONDITIONS (“TERMS”) OF PERSONAL LOAN (“FACILITY”)',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The following are the Terms of the Company which are supplemental to the Moneylending Agreement (“The Agreement”) entered into between The Company and you as the applicant (“The Applicant”) The Applicant has read, understood and agrees to be bound by these Terms and any additions or amendments as may be made there to by the Company at any time and from time to time which govern the Facility with prior notice to the Applicant.Any difference between the Facility amount, interest rate, monthly instalment or tenure applied for and the amount, interest rate, monthly instalment or tenure eventually approved by the Company will not affect the validity of these Terms. Reference to “Facility” means the Facility disbursed by the Company to the Applicant.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1. Facility Amount',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Facility Amount shall be the principal sum of the Facility approved by the Company and notified the Applicant in any manner as the Company deems fit, which sum shall not exceed the sum applied for',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '2. Purpose of the Facility',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant agrees to use the Facility solely for the purpose specified by the Applicant during the application stage.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '3. Interest Payment',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Once the application for the Facility is successful, the Company will inform the Applicant the approval together with the rate of interest (the "Prescribed Rate") that the Applicant is required to pay on the Facility.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Company reserves the right to vary the Prescribed Rate at any time and from time to time by giving prior notice to the Applicant of such variation. The Company’s notice of variation may be given in any manner as the Company deems appropriate. The variation shall take effect from the date specified in the notice given by the Company.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '4. Repayment',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'In consideration of the Company approving the application for the Facility, the Applicant agrees to pay the Company punctually and without previous demand the monthly instalments ("Monthly Instalments") and all other monies owing or payable at such times as prescribed and at the Prescribed Rate specified in the approval letter (“Approval Letter”) issued by the Company.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant shall commence the first Monthly Instalments on the date stated in the Approval Letter which is thirty (30) days from the date of disbursement of the Facility. The subsequent Monthly Instalments shall be paid at successive intervals of one (1) month each until the full amount of the Facility and all interest thereon have been fully paid.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Company reserves the right to demand, terminate or recall the Facility and demand repayment of the aggregate of the remaining unpaid Monthly Instalments, cost, fees and all other sums due and payable under the Facility at the Company’s absolute discretion upon the occurrence of an Event of Default (as defined below).',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '5. Events of Default',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Facility, interest thereon and all other monies for the time being owing or remaining unpaid by the Applicant under these Terms and any other agreements shall become due and immediately repayable by the Applicant to the Company and the Company shall be entitled to recover the same with interest thereon together with any costs and fees due on the part of the Applicant if any of the following event or events of default(s) including but not limited to the following shall occur:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. if the Applicant fails to pay any monies due and payable to the Company;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. if the Applicant defaults or fails to perform any of its undertakings, agreements or any of these Terms herein;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. if the Applicant commits an act of bankruptcy or enters into any composition or arrangement with or for the benefit of its creditors;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. if any distress or execution is levied or enforced upon any of the Applicant’s property;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'e. if the Applicant serves any custodial sentence, becomes insane or dies;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'f. if there shall be any material change in the financial condition of the Applicant which in the Company’s reasonable opinion is likely to prejudice the Applicant’s ability to service the Facility and interest thereon;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'g. any representation or statement made by the Applicant is materially incorrect or misleading or not complied with;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'h. if a change in applicable law or regulation makes it impossible or unlawful for the Company to continue making available the Facility to the Applicant;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'i. if any event or events has/have occurred or a situation exists which could or might prejudice the Applicant’s performance of the terms of these Terms;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'j. any other event or series of events, whether related or not, including act of violence, terrorism, hostility of war, national emergency, rebellion, revolution, insurrection, usurpation or occurrence of any epidemic, pandemic of whatsoever description or other calamity or other change in circumstances whatsoever has or have occurred which in the reasonable opinion of the Company:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'i. would or might render it inadvisable or impractical for the Company to make, maintain or fund the Facility or to continue to do so to allow any utilization or further utilization of the Facility; or',
            'paddingLeft': '45px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'ii. could or might affect the ability or willingness of the Applicant to observe or comply with any obligation on the part of the Applicant, to be observed or complied in relation to the Facility or make it improbable that the Applicant would be able or willing to do so;',
            'paddingLeft': '45px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'k. if legal proceedings, suit o action of any kind whatsoever be instituted against the Applicant.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '6. Assignment',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Company shall be entitled to assign and/or transfer the whole or any part of the Company’s rights or obligations under these Terms at any time with notice to the Applicant.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '7. Early Settlement',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant may prepay the whole outstanding amount under the Facility at any time. The Applicant shall provide the Company with thirty (30) days written notice should the Applicant intend to settle the outstanding amount due for the Facility in full.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '8. Right to Disclose',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant irrevocably authorizes and permits the Company, its officers and employees to disclose and furnish all information concerning the Facility, these Terms, present and future accounts of the Applicant and any other matters relating to the Applicant or its business and operations to:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. other financial institutions granting or intending to grant any credit facilities to the Applicant, the Credit Bureau or any other central credit bureau established by Bank Negara Malaysia (“BNM”), any other relevant authority as may be authorized by law to obtain such information or such authorities/agencies established by BNM;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. any current or future corporation which may be associated with or related to the Bank (as defined in the Companies Act 2016), including representative and branch offices and their respective representatives as well as subsidiaries of the Bank’s holding company;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. the Security Parties or any party intending to provide security in respect of the Facility; or',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. the Bank’s auditors, solicitors and/or other agents in connection with the recovery of moneys due and payable hereunder.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant hereby irrevocably consents to such disclosure and confirms that the Company, its officers and employees shall be under no liability for furnishing such information or for the consequences of any reliance which may be placed on the information so furnished in accordance with these Terms.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '9. Processing of Personal Information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant hereby agrees and consents to the holding, collection and use of all personal data provided to the Company by the Applicant and/or acquired by the Company from the public domain, as well as personal data that arises as a result of the provision of services to the Applicant in connection with the Facility in accordance with the Privacy Notice of the Company as may be amended from time to time.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '10. Waiver',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Terms herein may be waived by the Company in whole or in part with or without conditions with notice to the Applicant without prejudicing the rights of the Company. Any failure by the Company to enforce any of the provisions hereunder or any forbearance delay or indulgence granted by the Company to the Applicant hall not mean that the Company has waived any of the Company’s rights hereunder.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '11. Appointment of Agent',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Company shall have the right, at its sole discretion, to appoint an agent of its choice to collect all and any sums due to the Company from the Applicant under these Terms. The Company may disclose the Applicant’s information relating to the Facility to the agent for such collection purposes.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '12. Telephone Monitoring and Recording',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Subject to applicable laws, the Company may record and the Applicant consents to the Company recording all telephone conversation made with the Applicant for purposes which may include sales, training, investigation purposes etc. The Applicant agrees that:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. all telephone recordings shall belong to the property of the Company;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. the Company shall be entitled to use such recordings as evidence in any disputes.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '13. Representations and Warranties',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant hereby represents and warrants to the Company that:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. the Applicant has the capacity to execute, deliver and perform the Terms herein;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. these Terms constitute legal, valid and binding obligations enforceable against the Applicant;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. all acts, conditions, things, permissions, consents, authorizations, approvals, licenses and exemptions which are required to be done, executed, delivered, fulfilled, performed or obtained to enable the Applicant to lawfully enter into and exercise and perform the Applicant\'s rights and obligations hereunder and under any related documents executed by the Applicant, have been done, executed, delivered, fulfilled, performed or obtained and are in full force and effect;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. the Applicant’s accepts and to perform the obligations under these Terms according to any laws, regulations, orders or decrees of any governmental authority, body, agency, and court;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'e. the information furnished by the Applicant to the Company in connection with the Facility is accurate, correct, true and complete and there has been no omission whatsoever which would render the said information inaccurate, incorrect, erroneous, misstated, untrue, incomplete or misleading in any respect. The Applicant shall promptly notify the Company in writing if the said information shall cease to be so and/or of any change thereto;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'f. the Applicant is not in default under any agreement to which the Applicant is a party or by which the Applicant may be bound; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'g. the Applicant is not an undischarged bankrupt and no bankruptcy proceedings, legal action, litigation, arbitration, administrative, civil or criminal proceedings are presently current, pending or threatened against the Applicant, which will affect the ability of the Applicant to comply with the obligations under these Terms.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '14. Suspense Account',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Any money received by the Company in respect of the Facility may be kept to the credit of a suspense account for so long as the Company reasonably thinks fit without any obligation in the meantime to apply the money towards settlement of any liabilities due from the Applicant to the Company',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '15. Successors',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These Terms shall be binding upon the heirs, liquidators, receivers, representatives, permitted assigns and successors-in-title of the Applicant and enforceable by the successors-in-title and assigns of the Company',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '16. Indemnity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant agrees to indemnify and keep harmless and indemnified the Company from and against all actions claims, demands, proceedings, losses, damages, costs, charges and expenses whatsoever which the Company may incur or sustain in connection with or arising out of the Applicant’s breach of any of the Terms of the Facility',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '17. Severability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Any term, condition, stipulation, provision, covenant or undertaking in these Terms or any part which is illegal, void, prohibited or unenforceable in any jurisdiction shall as to such jurisdiction be ineffective to the extent of such illegality, voidness, prohibition or unenforceability without invalidating the remaining provisions or parts of these Terms and any such illegality, voidness, prohibition or unenforceability in any jurisdiction shall not invalidate or render illegal, void or unenforceable any other term, condition, stipulation, provision, covenant or undertaking in any other jurisdiction.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '18. Cross Default',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If an Events of Default has occurred pursuant to Clause 5, the Company has the right to cancel, terminate and demand payment of all sums due and payable in respect of other facilities granted to the Applicant by the Company including but not limited to existing facility with the Company.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '19. No Liability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Company is not liable if the Company disburse the Facility Amount into the bank account in accordance with the information provided by the Applicant during the application stage when such information provided by the Applicant is not accurate or wrong.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '20. Statement Provided by the Company',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant agrees that a statement of account signed the duly authorised officer of the Company shall be binding and conclusive evidence of the amount due under the Facility. Any discrepancies in the statement of account shall be raised by the Applicant to the Company within fourteen (14) days from the date of the statement, failing which, the statement would be deemed conclusive.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '21. Fee and Expenses',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Applicant shall pay the stamp duties and fees of Commissioner for Oaths incurred in connection with the execution of the Agreement.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '22. Governing Law',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Terms contained herein shall be governed by and construed in accordance with the laws of Malaysia. The Applicant hereby agrees to submit to the non-exclusive jurisdiction of the courts of Malaysia.',
            'paddingLeft': '25px',
            'underline': false
        },
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
